import React from 'react';
import { Briefcase, Users, Crown } from 'lucide-react';
import './WhoShouldTake.css';

const WhoShouldTake = () => {
  const audiences = [
    {
      icon: Briefcase,
      gradient: 'linear-gradient(135deg, #9C4DF4 0%, #7C3AED 100%)',
      title: 'CHROs & HR Heads',
      description: 'Leaders who want a quick, objective read on their organization\'s culture health.'
    },
    {
      icon: Users,
      gradient: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
      title: 'HRBPs & People Leaders',
      description: 'Managers seeking fast, high-signal insights to understand team alignment and sentiment.'
    },
    {
      icon: Crown,
      gradient: 'linear-gradient(135deg, #9C4DF4 0%, #3B82F6 100%)',
      title: 'CEOs & Business Unit Leaders',
      description: 'Executives who want a concise diagnostic of cultural factors influencing performance.'
    }
  ];

  return (
    <section className="who-should-take section">
      <div className="container">
        <div className="who-should-take-header">
          <h2 className="section-title">Who Should Take This Assessment</h2>
        </div>
        
        <div className="audience-grid">
          {audiences.map((audience, index) => {
            const IconComponent = audience.icon;
            return (
              <div key={index} className="audience-card">
                <div className="audience-icon" style={{ background: audience.gradient }}>
                  <IconComponent size={28} strokeWidth={2.5} />
                </div>
                <div className="audience-content">
                  <h3 className="audience-title">{audience.title}</h3>
                  <p className="audience-description">{audience.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhoShouldTake;

